import React from 'react';
import { Zap, Phone, Mail, MapPin, Clock, Facebook, Instagram, Twitter } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#1f1f1f] pt-20 pb-10 border-t border-[#3a3a3a]" data-id="element-15">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-17">
          {/* Brand */}
          <div className="space-y-6" data-id="element-18">
            <div className="flex items-center gap-3" data-id="element-19">
              <div className="bg-[#FFD700] p-2 rounded-xl flex items-center justify-center" data-id="element-20">
                <Zap className="w-6 h-6 text-[#1f1f1f] fill-[#1f1f1f]" data-id="element-21" />
              </div>
              <span className="text-xl font-extrabold tracking-tight text-white uppercase italic" data-id="element-22">
                CABALLERO'S <br data-id="element-23" />
                <span className="text-white" data-id="element-24">ELECTRIC</span>
              </span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-25">
              Nevada's trusted electrical contractor providing top-tier
              residential, commercial, and solar services with honesty and
              quality.
            </p>
            <div className="flex gap-4" data-id="element-26">
              <a href="#" className="w-10 h-10 rounded-full bg-[#2d2d2d] flex items-center justify-center text-gray-400 hover:bg-[#FFD700] hover:text-[#1f1f1f] transition-colors" data-id="element-27">
                <Facebook className="w-5 h-5" data-id="element-28" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-[#2d2d2d] flex items-center justify-center text-gray-400 hover:bg-[#FFD700] hover:text-[#1f1f1f] transition-colors" data-id="element-29">
                <Instagram className="w-5 h-5" data-id="element-30" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-[#2d2d2d] flex items-center justify-center text-gray-400 hover:bg-[#FFD700] hover:text-[#1f1f1f] transition-colors" data-id="element-31">
                <Twitter className="w-5 h-5" data-id="element-32" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-33">
            <h3 className="text-white font-bold mb-6 uppercase tracking-wide" data-id="element-34">
              Quick Links
            </h3>
            <ul className="space-y-4" data-id="element-35">
              <li data-id="element-36">
                <a href="#services" className="text-gray-400 hover:text-[#FFD700] text-sm transition-colors font-medium" data-id="element-37">
                  Our Services
                </a>
              </li>
              <li data-id="element-38">
                <a href="#why-us" className="text-gray-400 hover:text-[#FFD700] text-sm transition-colors font-medium" data-id="element-39">
                  Why Choose Us
                </a>
              </li>
              <li data-id="element-40">
                <a href="#reviews" className="text-gray-400 hover:text-[#FFD700] text-sm transition-colors font-medium" data-id="element-41">
                  Customer Reviews
                </a>
              </li>
              <li data-id="element-42">
                <a href="#service-area" className="text-gray-400 hover:text-[#FFD700] text-sm transition-colors font-medium" data-id="element-43">
                  Service Area
                </a>
              </li>
              <li data-id="element-44">
                <a href="#" className="text-gray-400 hover:text-[#FFD700] text-sm transition-colors font-medium" data-id="element-45">
                  Get a Quote
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-46">
            <h3 className="text-white font-bold mb-6 uppercase tracking-wide" data-id="element-47">
              Contact Us
            </h3>
            <ul className="space-y-4" data-id="element-48">
              <li className="flex items-start gap-3 text-sm text-gray-400" data-id="element-49">
                <Phone className="w-5 h-5 text-[#FFD700] shrink-0" data-id="element-50" />
                <a href="tel:+17025550123" className="hover:text-white transition-colors font-medium" data-id="element-51">
                  (702) 555-0123
                </a>
              </li>
              <li className="flex items-start gap-3 text-sm text-gray-400" data-id="element-52">
                <Mail className="w-5 h-5 text-[#FFD700] shrink-0" data-id="element-53" />
                <a href="mailto:info@caballeroselectric.com" className="hover:text-white transition-colors font-medium" data-id="element-54">
                  info@caballeroselectric.com
                </a>
              </li>
              <li className="flex items-start gap-3 text-sm text-gray-400" data-id="element-55">
                <MapPin className="w-5 h-5 text-[#FFD700] shrink-0" data-id="element-56" />
                <span className="font-medium" data-id="element-57">
                  Serving Las Vegas, Henderson, and surrounding areas
                </span>
              </li>
            </ul>
          </div>

          {/* Hours & License */}
          <div data-id="element-58">
            <h3 className="text-white font-bold mb-6 uppercase tracking-wide" data-id="element-59">
              Hours & Info
            </h3>
            <ul className="space-y-4" data-id="element-60">
              <li className="flex items-start gap-3 text-sm text-gray-400" data-id="element-61">
                <Clock className="w-5 h-5 text-[#FFD700] shrink-0" data-id="element-62" />
                <div data-id="element-63">
                  <p className="text-white font-bold mb-1" data-id="element-64">
                    24/7 Emergency Service
                  </p>
                  <p className="font-medium" data-id="element-65">Regular Hours:</p>
                  <p className="font-medium" data-id="element-66">Mon - Fri: 7:00 AM - 6:00 PM</p>
                  <p className="font-medium" data-id="element-67">Sat - Sun: By Appointment</p>
                </div>
              </li>
              <li className="mt-6 pt-6 border-t border-[#3a3a3a]" data-id="element-68">
                <p className="text-sm text-gray-400 font-bold mb-1" data-id="element-69">
                  NV License #123456789
                </p>
                <p className="text-sm text-gray-400 font-medium" data-id="element-70">
                  Fully Licensed, Bonded & Insured
                </p>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-[#3a3a3a] flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-71">
          <p className="text-gray-500 text-sm font-medium" data-id="element-72">
            © {new Date().getFullYear()} Caballero's Electric. All rights
            reserved.
          </p>
          <div className="flex gap-6 text-sm text-gray-500 font-medium" data-id="element-73">
            <a href="#" className="hover:text-white transition-colors" data-id="element-74">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-75">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}